import React, { FormEventHandler } from 'react';

const Search = ({
	onChange,
}: {
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
	return (
		<span className='search-wrap'>
			<input title='Search by City or State'
				className='search'
				type='text'
				placeholder='Search by City or State'
				onInput={onChange}
			/>
		</span>
	);
};

export default Search;
